import { Component, Vue } from 'vue-property-decorator';
import WithRender from './signup.html';
import config from '@/settings/config.js';
import _axios from '@/services/axios';
import Loading from 'vue-loading-overlay';

@WithRender
@Component({
  components: {
    Loading
  }
})
export default class SignUp extends Vue {
  isLoading = false;
  submitted = false;
  form = {
    companyName: '',
    fullName: '',
    email: ''
  }

  async onSubmit(event: any) {
    event.preventDefault()
    if (this.form.companyName.trim() == '') {
      this.ErrorNotification('Please enter your company name', 'danger');
      return;
    }
    if (this.form.fullName.trim() == '') {
      this.ErrorNotification('Please enter your full name', 'danger');
      return;
    }
    if (this.form.email.trim() == '') {
      this.ErrorNotification('Please enter your email address', 'danger');
      return;
    }

    try {
      this.isLoading = true;
      await _axios.post(config.gateway + "customerdata/Company/register", this.form);
      this.submitted = true;
    } catch (error) {
      const err = error as any;
      this.ErrorNotification(this.ErrorMessage(err), 'danger');
    }
    finally {
      this.isLoading = false;
    }
  }

  private ErrorMessage(err: any): string {
    const status = err.response && err.response.status;
    if (status == 429)
      return 'Too many attempts, please try again in a few minutes.';
    if (status == 400 && typeof err.response.data === 'string')
      return err.response.data;
    if (status == 400)
      return 'Please check that your email address is valid.';
    return 'please check that you have data or your internet connection is on.';
  }

  private ErrorNotification(message: string, type: string) {
    this.$bvToast.toast(message, {
      title: 'Notification',
      variant: type,
      autoHideDelay: 5000,
    });
  }
}
